import { useCallback, useState } from 'react';

/**
 * 预览态：数据就绪后仍保持骨架，直到 ECharts onChartReady，避免「加载结束 → 空白框 → 出图」。
 * 在 render 期根据 enabled/resetKey 同步复位，避免 effect 晚一拍造成空白闪帧。
 */
const usePreviewChartPaintGate = (enabled, resetKey) => {
	const [gate, setGate] = useState(() => ({
		enabled: Boolean(enabled),
		resetKey,
		painted: !enabled,
	}));

	if (gate.enabled !== Boolean(enabled) || gate.resetKey !== resetKey) {
		setGate({
			enabled: Boolean(enabled),
			resetKey,
			painted: !enabled,
		});
	}

	const onChartReady = useCallback(() => {
		setGate((prev) => (prev.painted ? prev : { ...prev, painted: true }));
	}, []);

	const active = Boolean(enabled);

	return {
		showPaintSkeleton: active && !gate.painted,
		onChartReady: active ? onChartReady : undefined,
	};
};

export default usePreviewChartPaintGate;
